export default __webpack_public_path__ + "static/media/download-disabled.09405e95.svg";